import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import "bootstrap/dist/css/bootstrap.css";
import "./login.scss";
import UsersService from "services/http/users-service";
import logo_ooredoo from "assets/img/logo_ooredoo.png";
import Utils, { CUSTOM_MESSAGES } from "utils";
import { CustomButton, ToastNotification, Input, Alert } from 'components/shared';
import { useHistory } from "react-router";
import jwtWorker from 'utils/jwt-worker';
import { Footer } from 'components/layout';

export const ChangePassword = () => {
    const history = useHistory();
    const [credentials, setCredentials] = useState({
        username: null, password: null, newPassword: null
    });
    const [actionState, setActionState] = useState({
        loading: false, token: null, error: null
    });
    const [loading, setLoading] = useState(false);
    const { handleSubmit } = useForm();
    const childRef = useRef();

    const searchParam = (param) => {
        return new URLSearchParams(window.location.search).get(param);
    }
    //submit form action
    function submitForm() {
        setLoading(true);
        setActionState({ ...actionState, loading: true, error: null });
        if (jwtWorker.isUserLogged()) {
            let _user = {
                oldPassword: credentials.password,
                password: credentials.newPassword,
                newPassword: credentials.newPassword
            }
            UsersService.changePassword(_user).then(result => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "success",
                    title: result.message,
                    message: CUSTOM_MESSAGES.PWD_CHANGED_SUCCESSFULLY,
                    durable: false
                });
                setTimeout(() => {
                    history.push("/");
                }, 500);
            }, failure => {
                onFailed(failure)
            });
        }
        else {
            let payload = { ...credentials, username: searchParam("username"), uuidToken: searchParam("uuid") };
            UsersService.firstLogin(payload).then(result => {
                onSuccess(result);
            }, failure => {
                onFailed(failure)
            });
        }
    }

    //on success case
    const onSuccess = (result) => {
        Promise.resolve(jwtWorker.setTokenInStorage(result.authorization)).then(() => {
            window.location.reload(false);
        });
    }

    //on failure login
    const onFailed = (failure) => {
        setLoading(false);
        setActionState({ ...actionState, loading: false, error: failure })
    }

    return (
        <div className="container">
            <div className="mt-3">
                <a href={window.location.origin + process.env.PUBLIC_URL}> <i className="bi bi-arrow-left" /> Return back</a>
            </div>
            <div className='m-auto w-50'>
                <div className="justify-content-center">
                    <div className="justify-content-center">
                        <div className="brand text-center my-4">
                            <img src={logo_ooredoo} alt="Ooredoo" width={"50%"} />
                        </div>
                        <div className="card mt-4">
                            <div className="card-body">
                                <h4 className="card-title text-center">{CUSTOM_MESSAGES.CHENAGE_PASSWORD_WIEW_TITLE}</h4>
                                <form onSubmit={handleSubmit(submitForm)} className="my-login-validation pt-2">
                                    <Input
                                        id="username"
                                        placeholder="Username"
                                        icon="bi bi-person"
                                        disabled
                                        parentClass="my-2"
                                        value={searchParam("username")}
                                    />
                                    <Input id="password"
                                        name='Password'
                                        required
                                        onChange={e => { setCredentials({ ...credentials, password: e.target.value }) }}
                                        type="password"
                                        parentClass="my-2"
                                        placeholder='Current Password'
                                        icon="pi pi-lock"
                                    />
                                    <Input id="newPassword"
                                        required
                                        onChange={e => { setCredentials({ ...credentials, newPassword: e.target.value }) }}
                                        type="password"
                                        parentClass="my-2"
                                        placeholder='New Password'
                                        icon="pi pi-lock"
                                    />
                                    <hr />
                                    <CustomButton
                                        type="submit"
                                        label={Utils.labelTemplate(<>   <i className="bi bi-check-circle" /> Submit  </>, loading, "Loading...")}
                                        className="btn btn-primary btn-block"
                                    />
                                    {
                                        actionState.error && <Alert icon="bi bi-x-circle" iconSize="16px" type="danger" content={actionState.error} flex />
                                    }
                                </form>
                                <ToastNotification ref={childRef} />
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );

}